import {
  wellbeingMaterialEngagementSearchSchema,
  wellbeingMaterialEngagementViewColumns,
  mapWellbeingMaterialEngagementViewQuery,
} from "./WellbeingMaterialEngagementView.default";
import ManagedGridView from "../../controls/ManagedGridView";
import { SearchQuery } from "../../code/search-query/search-query";
import { getMaterialEngagement } from "../../repository/data.repository";
import { createGridRequest } from "../../hooks/useGridRequest";

export interface WellbeingMaterialEngagementViewProps {
  readonly trigger?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

// Read-only — engagement rows are recorded by the consumption app, not authored here.
function WellbeingMaterialEngagementView(
  props: WellbeingMaterialEngagementViewProps,
) {
  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={wellbeingMaterialEngagementViewColumns}
      schema={wellbeingMaterialEngagementSearchSchema}
      mapQuery={mapWellbeingMaterialEngagementViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getMaterialEngagement, { retry: true })}
      pageSize={100}
    />
  );
}

export default WellbeingMaterialEngagementView;
